module.exports = __webpack_public_path__ + "media/images/checkmark-purple-346691d7f97e500e1f74ab419acdc88c.svg";